import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useModal } from 'core';
import {
    CloseButton, DraftButton, ModalButtons, ModalHeader, ModalText,
    ModalWrapper, PublishButton, Subtitle, Title,
} from './style';
import closeIcon from './close.svg';

export const ProjectPublishModal: FC<{
    onClick: (publish: boolean) => void;
    onSaveDraft?: () => void;
}> = ({ onClick, onSaveDraft }) => {
    const { t } = useTranslation();
    const modal = useModal();

    return (
        <ModalWrapper role="dialog" aria-modal="true" aria-labelledby="project-save-title" aria-describedby="project-save-description">
            <ModalHeader>
                <ModalText>
                    <Title id="project-save-title">{t('project_edit.publishModal.title')}</Title>
                    <Subtitle id="project-save-description">{t('project_edit.publishModal.subtitle')}</Subtitle>
                </ModalText>
                <CloseButton type="button" onClick={() => modal.hide()} aria-label={t('close')}>
                    <img src={closeIcon} width={24} height={24} alt="" />
                </CloseButton>
            </ModalHeader>
            <ModalButtons>
                <PublishButton type="button" onClick={() => onClick(true)}>
                    {t('project_edit.publishModal.buttons.save')}
                </PublishButton>
                <DraftButton type="button" onClick={() => onSaveDraft ? onSaveDraft() : onClick(false)}>
                    {t('project_edit.publishModal.buttons.draft')}
                </DraftButton>
            </ModalButtons>
        </ModalWrapper>
    );
};
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useModal } from 'core';
import {
    CloseButton, DraftButton, ModalButtons, ModalHeader, ModalText,
    ModalWrapper, PublishButton, Subtitle, Title,
} from './style';
import closeIcon from './close.svg';

export const ProjectPublishModal: FC<{
    onClick: (publish: boolean) => void;
    onSaveDraft?: () => void;
}> = ({ onClick, onSaveDraft }) => {
    const { t } = useTranslation();
    const modal = useModal();

    return (
        <ModalWrapper role="dialog" aria-modal="true" aria-labelledby="project-save-title" aria-describedby="project-save-description">
            <ModalHeader>
                <ModalText>
                    <Title id="project-save-title">{t('project_edit.publishModal.title')}</Title>
                    <Subtitle id="project-save-description">{t('project_edit.publishModal.subtitle')}</Subtitle>
                </ModalText>
                <CloseButton type="button" onClick={() => modal.hide()} aria-label={t('close')}>
                    <img src={closeIcon} width={24} height={24} alt="" />
                </CloseButton>
            </ModalHeader>
            <ModalButtons>
                <PublishButton type="button" onClick={() => onClick(true)}>
                    {t('project_edit.publishModal.buttons.save')}
                </PublishButton>
                <DraftButton type="button" onClick={() => onSaveDraft ? onSaveDraft() : onClick(false)}>
                    {t('project_edit.publishModal.buttons.draft')}
                </DraftButton>
            </ModalButtons>
        </ModalWrapper>
    );
};
